import React, { useState, useEffect } from "react";
import { Main, Content } from "../../components/Layout";
import api from "../../services/api";
import { Col, Row } from "react-bootstrap";
import Slct from "../../components/Slct";
import Loading from "../../components/Loading";
import Pagenation from "../../components/Pagenation";
import getCommercial from "../../util/getCommercial";
import StatusFlag from "../../components/StatusFlag";
import { IntegerNumber } from "../../components/Input";
import useWrapper from "../../hooks/useWrapper";
import { toast } from "react-toastify";
import useFormat from "../../hooks/utils/useFormat";
import Button from "../../components/Button";
import Accordion2 from "../../components/Accordion";
import TableResponsive from "../../components/TableResponsive";

export default function Groups() {
  const { setbreadcrumb, config } = useWrapper();
  const { formatQuery } = useFormat();

  const [isLoadingEssential, setisLoadingEssential] = useState(false);
  const [isLoadingCommercials, setisLoadingCommercials] = useState(false);
  const [isWaitingResponse, setisWaitingResponse] = useState(true);
  useEffect(() => {
    setisWaitingResponse(isLoadingEssential || isLoadingCommercials);
  }, [isLoadingEssential, isLoadingCommercials]);

  const [commercials, setcommercials] = useState([]);
  const [institutions, setinstitutions] = useState([]);
  const [courses, setcourses] = useState();
  useEffect(() => {
    (async () => {
      try {
        setisLoadingEssential(true);
        const _commercials = await getCommercial(null, null, "?is_class=1&joins=institution,course");
        setcommercials(
          [{ value: null, label: "-- Todas --" }].concat(
            _commercials?.map(__commercial => ({
              ...__commercial,
              trainees: [{ value: null, label: "-- Todos --" }].concat(
                __commercial.trainees?.map(__trainee => ({
                  value: __trainee.id,
                  label: __trainee.name,
                })),
              ),
            })),
          ),
        );
        const { data: _institutions } = await api.get("institutions?joins=null&paginate=false", config);
        setinstitutions(
          [{ value: null, label: "-- Todas --" }].concat(
            _institutions?.map(__institution => ({
              value: __institution.id,
              label: __institution.title || "-",
            })),
          ),
        );

        const { data: _courses } = await api.get("courses", config);
        setcourses(
          [{ value: null, label: "-- Todos --" }].concat(
            _courses.map(__course => ({
              value: __course.id,
              label: __course.title,
            })),
          ),
        );
      } catch (__error) {
        console.log("__error", __error);
        toast.error("Erro ao tentar carregar a lista de Turmas e Instituições.");
      } finally {
        setisLoadingEssential(false);
        applyFilter(filter);
      }
    })();
    // eslint-disable-next-line react-hooks/exhaustive-deps -- intentional mount-only fetch. `applyFilter` is redefined every render (it closes over unmemoized `config` from context) and `config` itself is a new object every WrapperProvider render, so adding either would refire this on every render instead of once on mount.
  }, []);

  const [commercialsTable, setcommercialsTable] = useState();
  const filter_init = {};
  const [filter, setfilter] = useState(filter_init);
  const applyFilter = async (__filter, __setPreset) => {
    document.querySelector("#page-filter .accordion-button[aria-expanded='true']")?.click();
    try {
      setisLoadingCommercials(true);
      const _filter = __filter || filter;
      if (!!__filter) {
        setfilter(__filter);
      }
      const { search_type, ...query } = _filter;
      const _query = `?is_class=1&joins=institution,course&limite=30&paginate=true&${formatQuery(query)}`;
      const _commercials = await getCommercial(null, null, _query);
      setcommercialsTable(_commercials);
    } catch (__error) {
      console.log("__error", __error);
      toast.error("Problemas ao tentar carregar as turmas.");
    } finally {
      setisLoadingCommercials(false);
    }
  };

  useEffect(() => {
    setbreadcrumb([{ label: "Turmas" }]);
  }, [setbreadcrumb]);

  return (
    <Main>
      {!isLoadingEssential ? (
        <Content>
          <Row>
            <Col>
              <h2 className="mini-title">Listagem de Turmas:</h2>
              <p className="small-label mb-4">
                Confira todas as turmas registradas, com informações essenciais e acesso a detalhes completos sobre cada
                uma.
              </p>
            </Col>
          </Row>
          <Accordion2 id="page-filter">
            <Accordion2.Item eventKey={`page-filter`}>
              <Accordion2.Header>
                <span>Filtro</span>
                <Accordion2.Extras>
                  <span>{commercialsTable?.total} resultados</span>
                </Accordion2.Extras>
              </Accordion2.Header>
              <Accordion2.Body>
                <Row>
                  <Col sm={3}>
                    <span>Status</span>
                    <Slct
                      isDisabled={!!isWaitingResponse}
                      value={filter?.status}
                      options={[
                        { value: null, label: "-- Todos --" },
                        { value: "active", label: "Ativas" },
                        { value: "canceled", label: "Canceladas" },
                        { value: "finished", label: "Finalizadas" },
                      ]}
                      onChange={__ev => {
                        setfilter({
                          ...filter,
                          status: __ev.value,
                        });
                      }}
                      placeholder="..."
                    />
                  </Col>
                  <Col sm={3}>
                    <span>Instituição</span>
                    <Slct
                      isDisabled={!!isWaitingResponse}
                      value={filter?.institution_id}
                      options={institutions || []}
                      onChange={__ev => {
                        setfilter({
                          ...filter,
                          institution_id: __ev.value,
                        });
                      }}
                      placeholder="..."
                    />
                  </Col>
                  <Col sm={3}>
                    <span>Curso</span>
                    <Slct
                      isDisabled={!!isWaitingResponse}
                      value={filter?.courser_id}
                      options={courses || []}
                      onChange={__ev => {
                        setfilter({
                          ...filter,
                          courser_id: __ev.value,
                        });
                      }}
                      placeholder="..."
                    />
                  </Col>
                  <Col className="flex">
                    <span>Ano/Período</span>
                    <div className="ano-periodo">
                      <IntegerNumber
                        disabled={!!isWaitingResponse}
                        value={filter?.year}
                        valueChange={__ev => {
                          setfilter({
                            ...filter,
                            year: __ev,
                          });
                        }}
                        maxlength="4"
                      />
                      <Slct
                        isDisabled={!!isWaitingResponse}
                        options={[
                          { value: null, label: "1 e 2" },
                          { value: 1, label: "1" },
                          { value: 2, label: "2" },
                        ]}
                        placeholder="..."
                        value={filter.period}
                        onChange={e => {
                          setfilter({
                            ...filter,
                            period: e.value,
                          });
                        }}
                      />
                    </div>
                  </Col>
                </Row>
                <Row className="mt-2">
                  <Col sm={6}>
                    <span>Turma:</span>
                    <Slct
                      isDisabled={!!isWaitingResponse}
                      value={filter?.id}
                      options={commercials || []}
                      onChange={__ev => {
                        setfilter({
                          ...filter,
                          id: __ev.value,
                        });
                      }}
                      placeholder="..."
                    />
                  </Col>
                </Row>
                {!isWaitingResponse && (
                  <Row className="mt-3">
                    <Col>
                      <Button
                        color="primary"
                        size="sm"
                        onClick={() => {
                          applyFilter();
                        }}
                      >
                        Aplicar Filtro
                      </Button>
                      <Button
                        color="grey"
                        size="sm"
                        onClick={() => {
                          applyFilter(filter_init);
                        }}
                      >
                        Limpar Filtro
                      </Button>
                    </Col>
                  </Row>
                )}
              </Accordion2.Body>
            </Accordion2.Item>
          </Accordion2>
          <Row className="mt-4">
            <Col>
              {!isLoadingCommercials ? (
                <>
                  <TableResponsive
                    emptyMsg="Nenhuma turma encontrada."
                    table={{
                      head: [
                        { data: "ID" },
                        { data: "Turma" },
                        { data: <div className="text-end">Formandos</div> },
                        { data: <div className="text-end">Status</div> },
                      ],
                      body:
                        commercialsTable?.data?.map(__commercial => {
                          return {
                            link: `/groups/${__commercial.value}/registrationdata`,
                            data: [
                              { element: __commercial.value },
                              { element: __commercial.label },
                              {
                                element: (
                                  <div className="text-end">
                                    {__commercial.trainees_count?.total}/{__commercial.trainee_expectation}
                                  </div>
                                ),
                              },
                              {
                                element: (
                                  <div className="text-end">
                                    <StatusFlag status={__commercial.status} />
                                  </div>
                                ),
                              },
                            ],
                          };
                        }) || [],
                    }}
                  />
                  <Pagenation
                    current={commercialsTable?.page}
                    total={commercialsTable?.lastPage}
                    pageChange={__page => {
                      applyFilter({
                        ...filter,
                        page: __page,
                      });
                    }}
                    className="mt-4"
                  />
                </>
              ) : (
                <Loading />
              )}
            </Col>
          </Row>
        </Content>
      ) : (
        <Content>
          <Loading />
        </Content>
      )}
    </Main>
  );
}
